// extracted by mini-css-extract-plugin
export default {"title":"PersonalInfoClientForm_title__ypLLD"};